export enum Storage {
    LANGUAGE = 'i18nextLng',    
}
